(function () {
  'use strict';

  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
      , 'chart.js'
    );

  angular.module('MktzapApp.Controllers')
    .controller('ReportsDailyAttendencesController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'NotificationService', '$rootScope'];

  function reports ($scope, $http, $timeout, ngTableParams, NotificationService, $rootScope) {
    var vm = this;
    vm.loading = false;
    vm.exportAs = 'csv';
    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.download = function () {
      if (validateFields()) {
        vm.loading = true;
        $http.get(apiUrl + '/reports/daily-attendences', {
          params: {
            filters: vm.filters,
            exportAs: vm.exportAs,
            schedule: 0
          }
        })
          .then(function ({ data, status, headers, config }) {
            if (data) {
              if (data.alert == 'warning') {
                NotificationService.warningHandler(data, data.message);
              } else if (data.alert == 'success') {
                NotificationService.successHandler(data, data.message);
              }
            } else {
              NotificationService.warningHandler(null, $scope.labels.noRecordsFound);
            }
          }, function ({ data }) {
            $http.get(apiUrl + '/reports/daily-attendences', {
              params: {
                filters: vm.filters,
                exportAs: vm.exportAs,
                schedule: 1
              }
            })
              .then(function ({ data }) {
                NotificationService.warningHandler(null, $scope.labels.sendByEmail);
              }, function ({ data }) {
                if (data && data.message) {
                  NotificationService.errorHandler(data, data.message);
                } else {
                  NotificationService.errorHandler();
                }
              })
          })
        vm.loading = false
      }
    }

    const validateFields = () => {
      const toDate = moment(vm.filters.toDate, 'DD/MM/YYYY')
      const fromDate = moment(vm.filters.fromDate, 'DD/MM/YYYY')
      if (toDate < fromDate) {
        NotificationService.warningHandler('', $rootScope.labels.invalidInitialDate)
        return false
      }
      if (toDate.diff(fromDate, 'days') > 30) {
        NotificationService.warningHandler('', $rootScope.labels.dateMore30Days)
        return false
      }
      return true
    }

  }
})();
